export default function Logo({ inverted = false }) {
  const blue = inverted ? "#FFFFFF" : "#3B62A5";
  return (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg width="30" height="30" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <path d="M16 3 L29 13.5 V29 H3 V13.5 Z" fill={blue} />
        <rect x="13" y="19" width="6" height="10" fill={inverted ? "#3B62A5" : "#FFFFFF"} />
      </svg>
      <span className="leading-none">
        <span className={`block text-xl font-bold tracking-tight ${inverted ? "text-white" : "text-[#3B62A5]"}`}>HRG</span>
        <span className={`block text-[10px] font-tech uppercase tracking-[0.3em] ${inverted ? "text-white/70" : "text-slate-500"}`}>Service GmbH</span>
      </span>
    </span>
  );
}
